URL={ 
  "List":"/mast/matGroupmng/materialGroup/select",//物料类别管理-查询物料类别列表
	"ADD":"/mast/matGroupmng/materialGroup/add",//物料类别管理-添加物料组
	"MODIFY":"/mast/matGroupmng/materialGroup/modify",//物料类别管理-修改物料类别
	"FIND":"/mast/matGroupmng/materialGroup/find",//物料类别管理-查询物料类别
	"DEL":"/mast/matGroupmng/materialGroup/delete",//物料类别管理-删除物料类别
	"RESTORE":"/mast/matGroupmng/materialGroup/restore"//物料类别管理-恢复已删除物料类别
}

/**
 * 加载平台资源
 * @param {} data 
 * @param {*} cb 
 */
async function loadPlatResource(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.List,data);
  if(cb&&resResult){
    cb(resResult);
  }
}




export const URL_PLATFORM_RESOURCE=URL;

export default{
  loadPlatResource
}


